// extracted by mini-css-extract-plugin
export var arrow = "_ka-1";
export var content = "_ka-0";
export var highlighted = "_ka-2";